module.exports = __webpack_public_path__ + "img/brcj.0190942c.png";